import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=a12f52ac&scoped=true&"
import script from "./company-info.vue?vue&type=script&lang=js&"
export * from "./company-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12f52ac",
  null
  
)

export default component.exports